/**
 * Dev/Test Environment Configuration
 * Used for provisioning-admin-dev.anepanywhere.com
 */

export const testConfig = {
  environment: 'dev',
  hostname: 'provisioning-admin-dev.anepanywhere.com',

  api: {
    baseUrl: '/api',
    firmwareBaseUrl: 'https://provisioning-dev.anepanywhere.com',
  },

  oauth: {
    clientId: 'provisioning-dev',
    redirectUri: 'https://provisioning-admin-dev.anepanywhere.com/auth/callback',
    authUrl: 'https://keycloak.anepanywhere.com/realms/provisioning-anep/protocol/openid-connect/auth',
    tokenUrl: 'https://keycloak.anepanywhere.com/realms/provisioning-anep/protocol/openid-connect/token',
  },

  ui: {
    title: 'ANEP Device Provisioning [DEV]',
    logoUrl: '/logo.png',
    companyName: 'ANEP',
    primaryColor: '#215EA1',
  },

  dev: {
    debug: true,
  },
} as const;

export default testConfig;
